import React from 'react';
import Grid from '@material-ui/core/Grid';
import { FormControl, InputLabel } from '@material-ui/core';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';

const SiteTypeSelect = (props) => {
  const {type, handleChangeType} = props;
  return(
    <Grid item xs={12} sm={12} md={4}>
      <FormControl
        style={{
          marginLeft: '8px',
          marginRight: '8px',
          marginTop: '16px',
          marginBottom: '8px',
        }}
      >
        <InputLabel style={{ width: '200px' }} htmlFor="type">{'Type'}</InputLabel>
        <Select
          value={type}
          onChange={handleChangeType}
          name="type"
          style={{  width: '200px' }}
        >
          <MenuItem value={0}>{'Free floating'}</MenuItem>
          <MenuItem value={1}>{'Station'}</MenuItem>
          <MenuItem value={2}>{'Mixte'}</MenuItem>
          <MenuItem value={4}>{'No lock'}</MenuItem>
          <MenuItem value={5}>{'Longue durée'}</MenuItem>
        </Select>
      </FormControl>
    </Grid>
  );
}

export default SiteTypeSelect;



// WEBPACK FOOTER //
// ./src/components/Site/SiteTypeSelect.jsx